import { GeometryType } from "../../../core/geo/types";
import { pointChangeRetriever } from "./pointChangeRetriever";
import { GeometryChange } from "./types";
import { EditFeatureOptions } from "../../redux";
import { lineChangeRetriever } from "./lineChangeRetriever";
import { polygonChangeRetriever } from "./polygonChangeRetriever";
import { geometryCollectionChangeRetriever } from "./geometryCollectionChangeRetriever";
import { Feature } from "geojson";

export interface GeometryChangeRetriever {
    retrieveChange: (
        featureBefore: Feature | undefined,
        featureNow: Feature,
        featureOptions: EditFeatureOptions,
        projection?: string
    ) => GeometryChange[];
}

export const geometryChangeRetrievers: { [key in GeometryType]: GeometryChangeRetriever | undefined } = {
    LineString: lineChangeRetriever,
    Point: pointChangeRetriever,
    Polygon: polygonChangeRetriever,
    GeometryCollection: geometryCollectionChangeRetriever,
    MultiLineString: undefined,
    MultiPoint: undefined,
    MultiPolygon: undefined,
};
